import type { JSX } from 'react';

import type { BaseType } from 'antd/lib/typography/Base';

import { SpecificationDimensionsMultiselectField } from 'src/components/base/fields/SpecificationField/SpecificationDimensionsField/SpecificationDimensionsMultiselectField';
import { SpecificationDimensionsSimpleField } from 'src/components/base/fields/SpecificationField/SpecificationDimensionsField/SpecificationDimensionsSimpleField';
import {
  type IProductSpecificationFieldReference,
  ProductSpecificationFieldType,
} from 'src/types/reference/IProductSpecificationReference';

type SpecificationDimensionsFieldProps = {
  commonFieldProps: {
    errorType: BaseType;
    name: string;
    label?: string;
    description: string | null;
    disabled?: boolean;
  };
  field: IProductSpecificationFieldReference;

  containerClassName?: string;
  className?: string;
};

export function SpecificationDimensionsField({
  commonFieldProps,
  field,
  containerClassName,
  className,
}: Readonly<SpecificationDimensionsFieldProps>): JSX.Element {
  if (field.multiselect || field.showOptions) {
    return (
      <SpecificationDimensionsMultiselectField
        name={commonFieldProps.name}
        specificationField={field}
        className={className}
        containerClassName={containerClassName}
        errorType={commonFieldProps.errorType}
        disabled={commonFieldProps.disabled}
      />
    );
  }

  return (
    <SpecificationDimensionsSimpleField
      commonFieldProps={commonFieldProps}
      is3d={field.type === ProductSpecificationFieldType.DIM3D}
      allowedMeasureUnits={field.allowedMeasureUnits}
      className={className}
      containerClassName={containerClassName}
    />
  );
}
